import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface Language {
  code: string;
  label: string;
  flag: string;
}

const LANGUAGES: Language[] = [
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'cs', label: 'CZ', flag: '🇨🇿' }
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language?.split('-')[0] || 'cs';

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <div className="flex gap-1">
      {LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          className={cn(
            'flex items-center gap-1 px-2 py-1 border-none rounded bg-transparent text-sidebar-foreground/60 cursor-pointer text-xs font-medium transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
            currentLanguage === lang.code && 'bg-sidebar-accent text-sidebar-accent-foreground'
          )}
          title={lang.code === 'en' ? 'English' : 'Čeština'}
        >
          <span>{lang.label}</span>
        </button>
      ))}
    </div>
  );
}
